import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _defineProperty from '@babel/runtime/helpers/defineProperty';

var Feature = /*#__PURE__*/_createClass(function Feature(value) {
  var _this = this;
  _classCallCheck(this, Feature);
  _defineProperty(this, "get", function () {
    return "(".concat(_this.value, ")");
  });
  this.value = value;
  this.value = value;
});
var isFeature = function isFeature(expression) {
  return expression instanceof Feature;
};

export { Feature, isFeature };
//# sourceMappingURL=Feature.js.map
